import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import Nav from "../../components/nav"

import EmployeeInfo from "../../images/view-employee-info.png"
import SparkleTax from "../../images/sparkle-tax.png"

const taxation = () => {
  return (
    <Layout>
      <Seo
        title="Sparkle Taxation - Pay your Taxes with the Sparkle App"
        desc="Sparkle is offering small business owners pay for their taxes  offering an important role in the development of every economy as well as the growth of Small and Medium Enterprises"
      />

      <div className="taxation__hero">
        <div className="nav-wrapper bg__sparkle--black">
          <div className="container">
            <Nav />
          </div>
        </div>

        <div className="container">
          <div className="row align-center py-5">
            <div className="col-lg-6">
              <h1 className="mt-5 pt-lg-5 pt-4 hero__title sparkle--font__56">
                Know what to pay, any day, anytime​
              </h1>
              <div className="description--wrapper">
                <p className="mt-4 hero__description">
                  Our taxation feature automatically calculate and deduct your
                  taxes, so you know how much to remit to the government at
                  anytime.​
                </p>
              </div>
            </div>
            <div className="col-lg-5 my-4 offset-lg-1 order-first order-lg-last text-center">
              <img
                loading="lazy"
                src={SparkleTax}
                className="img-fluid banner--tribe-image position-relative mt-lg-5"
                alt="mark taxes off your to-do list anytime, from anywhere."
                title="mark taxes off your to-do list anytime, from anywhere."
              />
            </div>
          </div>
        </div>
      </div>

      <div className="payment position-relative">
        <div className="container">
          <div className="row align-center">
            <div className="col-lg-6 my-3">
              <h4 className="sparkle--title sparkle-deep-blue">
                Stay compliant without crunching the big numbers.
              </h4>
              <div className="description--wrapper">
                <p className="sparkle--paragraph">
                  No need to do the math! Simply send invoices and process
                  salary payments on the app and your VAT and PAYE taxes are
                  automatically deducted and displayed in the Tax section for
                  easy reference. Giving to Caesar has never been easier!​
                </p>

                
              </div>
            </div>

            <div className="col-lg-5 offset-lg-1 position-relative my-3 order-lg-last order-first">
              <img
                src={EmployeeInfo}
                className="img-fluid position-relative"
                alt="File your taxes anytime, anywhere, Taxes are easier than ever on Sparkle Business"
                title="File your taxes anytime, anywhere, Taxes are easier than ever on Sparkle Business"
              />
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row align-center py-lg-5 justify-content-center">
            <div className="col-lg-8 offset-lg-1 my-3">
              <h4 className="sparkle--title sparkle-deep-blue text-center mb-5">
                Important terms that aid you paying your taxes on Sparkle
              </h4>

              <Accordion allowZeroExpanded>
                <AccordionItem key={"1"}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      Handling my PAYE for my Workers and Tax deduction
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div>
                      <p>
                        Easily disburse your workers' PAYE as well as tax
                        deductions from your business to the appropriate
                        regulators
                      </p>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem key={"2"}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      Aiding in pension contributions
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div>
                      <p>
                        Pay contributions to your Workers' pension providers on
                        the go
                      </p>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem key={"3"}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      Making me eligible for NHF Housing with NHF Contributions
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div>
                      <p>
                        Easily pay National Housing Fund contributions for your
                        employees to increase their eligibility for the NHF
                        housing program.
                      </p>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default taxation
